<template>
    <div class="lms__superadmin_customer_service_sso_add">
        <div class="lms__superadmin_customer_service_sso_add_header">
            <view-actions
                :title="`${customerName}: SSO subscription`"
                :notify-title="'service'"
                :notify-process="$t('lms.customer.viwAction.notifyStopManaging')"
                :cancel-notify-active="false"
                :cancel-button-text="'Back'"
                :submit-button-text="'Save SSO'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'service-sso-create'"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: customerName,
                        to: customerTo
                    }
                ]"
                @emit-cancel="subscriptionStopEdit"
                @emit-submit="performSubmitValidate"
            />
        </div>
        <div class="lms__superadmin_customer_service_sso_add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="sidebarNav"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__superadmin_customer_service_sso_add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import { User } from '@/User'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-superadmin-customer-service-sso-add',
  components: { ComponentSidebar, PopNotify, ViewActions },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    routeCustomerId () {
      return this.$route.params.customerId
    },
    customerName () {
      return this.$store.getters.getLmsSuperadminCustomerName
    },
    customerTo () {
      return { name: 'lms-superadmin-customer-edit', params: { id: this.routeCustomerId } }
    },
    rootItemName () {
      return 'service-sso'
    },
    nameActionCreate () {
      return 'ebsServiceSSOCreate'
    },
    paramsActionCreate () {
      return { customerId: this.routeCustomerId }
    },
    sidebarNav () {
      let navArr = []

      navArr.push({ label: 'Melearning setup', name: 'lms-superadmin-customer-service-sso-add-mel-setup' })
      navArr.push({ label: 'Authentication', visible: () => false, name: 'lms-superadmin-customer-service-sso-add-authentication' })
      navArr.push({ label: 'Customer setup', visible: () => false, name: 'lms-superadmin-customer-service-sso-add-customer-setup' })

      return navArr
    }
  },
  methods: {
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-service-sso-create')
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-service-sso-create')
    },
    performSubmitValidateThenCallback (response) {
      const subscriptionId = response.id
      const customerId = this.routeCustomerId
      this.$router.push({ name: 'lms-superadmin-customer-service-sso-edit-authentication', params: { customerId, subscriptionId } })
    },
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('service-sso-submit')
    },
    //
    subscriptionStopEdit () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-customer-service-edit', params: { customerId: this.routeCustomerId, serviceKey: 'SSO' } })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomerservicessoaddedit.scss";
</style>
